import { type StaticImageData } from 'next/image';

import airCanImage from '~/assets/skill-onboarding/air-can.png';
import airCanvasImage from '~/assets/skill-onboarding/air-canvas.png';
import crosswordImage from '~/assets/skill-onboarding/crossword.png';
import newspaperPartyImage from '~/assets/skill-onboarding/newspaper-party.png';
import nytImage from '~/assets/skill-onboarding/nyt.png';
import tousImage from '~/assets/skill-onboarding/tous.png';
import tylerImage from '~/assets/skill-onboarding/tyler.png';
import workspaceImage from '~/assets/skill-onboarding/workspace.png';

export type SkillOnboardingImage = {
  image: StaticImageData;
  fileName: string;
};

/**
 * Pre-baked images keyed by `imageName` query-param value. The marketing site picks
 * a key from this catalogue; the deep-link flow uploads the bundled asset to a fresh
 * canvas. New entries are additive — extend the object and the union type narrows.
 */
export const SKILL_ONBOARDING_IMAGES = {
  'air-can': { image: airCanImage, fileName: 'air-can.png' },
  'air-canvas': { image: airCanvasImage, fileName: 'air-canvas.png' },
  crossword: { image: crosswordImage, fileName: 'crossword.png' },
  'newspaper-party': { image: newspaperPartyImage, fileName: 'newspaper-party.png' },
  nyt: { image: nytImage, fileName: 'nyt.png' },
  tous: { image: tousImage, fileName: 'tous.png' },
  tyler: { image: tylerImage, fileName: 'tyler.png' },
  workspace: { image: workspaceImage, fileName: 'workspace.png' },
} as const satisfies Record<string, SkillOnboardingImage>;

export type SkillOnboardingImageName = keyof typeof SKILL_ONBOARDING_IMAGES;

export const isSkillOnboardingImageName = (value: string): value is SkillOnboardingImageName =>
  value in SKILL_ONBOARDING_IMAGES;
